<template>
  <div ref="pageView" class="page-view pd-lr-20 container-view">
    <section class="title-section fixed-view">
      <e6-title
        >通关单信息
        <template slot="operate">
          <router-link
            v-if="operationSuper.编辑"
            class="operate__item"
            to="/baseCustomsDeclarationEdit"
          >
            <el-button icon="el-icon-plus" type="primary"></el-button>
          </router-link>

          <el-button
            class="g-form-section-search operate__item"
            title="导出"
            v-if="operationSuper.导出"
            icon="e6-icon-export_line"
            @click="handleExportClick"
            plain
          ></el-button>
          <el-button
            class="g-form-section-search operate__item"
            :class="{ 'is-open': !isSearch }"
            icon="e6-icon-search_line"
            @click="handleIsSearch"
            plain
          ></el-button>
        </template>
      </e6-title>
    </section>
    <!-- title end -->
    <!-- 查询条件 -->
    <section class="g-form-section form-section fixed-view" :hidden="isSearch">
      <e6-form-extend
        class="form-extend e6-form--validate"
        :class="{ 'is-open': isSearch }"
        :formExtend="formExtend"
        @submitForm="handlesSubmitForm"
      >
        <template slot-scope="slotForms">
          <el-form-item prop="forms.bTimeStr">
            <el-date-picker
              v-model="slotForms.forms.bTimeStr"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择开始日期"
              :picker-options="btimeDate()"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.eTimeStr">
            <el-date-picker
              v-model="slotForms.forms.eTimeStr"
              type="date"
              value-format="yyyy-MM-dd"
              placeholder="选择结束日期"
              :picker-options="etimeDate()"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item prop="forms.cdType">
            <dict-select
              v-model="slotForms.forms.cdType"
              placeholder="类型"
              :pkey="'customs_type'"
            ></dict-select>
          </el-form-item>
        </template>
        <template slot="submit">查询</template>
        <template slot="reset">重置</template>
      </e6-form-extend>
    </section>
    <!-- 查询条件 end -->
    <!-- 表格tab -->
    <section class="g-table-tab-section table-tab-section fixed-view">
      <e6-flank-fix>
        <template slot="fixRight">
          <i
            class="flank-fix__item e6-icon-field_line"
            @click="columSetVisible = !columSetVisible"
          ></i>
        </template>
      </e6-flank-fix>
    </section>
    <!-- 表格tab end -->
    <!-- 表格 -->
    <section class="table-section" :style="{ height: resizeViewHeight + 'px' }">
      <el-table
        v-loading="tableLoading"
        ref="multipleTable"
        border
        :data="tableData"
        height="100%"
      >
        <el-table-column
          v-for="(item, index) in localShowTableCols"
          :key="index"
          :show-overflow-tooltip="true"
          :prop="item.name"
          :label="item.title"
        ></el-table-column>
        <el-table-column align="center" label="附件" width="120">
          <template slot-scope="scope">
            <el-button @click="handlePreview(scope)" type="text" size="small">
              <img width="100%" :src="scope.row.attachment" alt=""
            /></el-button>
          </template>
        </el-table-column>
        <el-table-column align="center" label="操作" width="120">
          <template slot-scope="scope">
            <router-link
              v-if="operationSuper.编辑"
              :to="{
                path: '/baseCustomsDeclarationEdit',
                query: { pageType: '2', id: scope.row.id }
              }"
              >编辑</router-link
            >&nbsp;
            <el-button
              v-if="operationSuper.删除"
              @click="deleteRow(scope)"
              type="text"
              size="small"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
    </section>
    <!-- 表格 end -->
    <!-- 翻页 -->
    <section class="pagination-section fixed-view">
      <e6-pagination
        :total="total"
        :pageSize.sync="pageSize"
        :currentPage.sync="curPage"
        @currentChange="handleCurrentChange"
        @sizeChange="handleSizeChange"
      ></e6-pagination>
    </section>
    <!-- 翻页 end -->
    <!-- 表格列设置 -->
    <e6-column-set
      @setColumnSubmit="handleSetColumnSubmit"
      @setColumnCancel="handleSetColumnCancel"
      :columSetVisible.sync="columSetVisible"
      :hideTableCols.sync="copyHideTableCols"
      :showTableCols.sync="copyShowTableCols"
    ></e6-column-set>
    <!-- 表格列设置 end -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>

<script>
import { DeleteDataById } from "@/api/base/customsDeclaration";
import { mapActions } from "vuex";
import listInit from "@/mixins/listInit";
import { mergeFormExtend } from "_private/utils/merge";
import operationManage from "_private/mixins/operationManage";
export default {
  mixins: [listInit, operationManage],
  data() {
    return {
      isSearch: false,
      formExtend: {
        forms: {
          bTimeStr: "",
          eTimeStr: "",
          cdType: ""
        },
        extends: []
      },
      formsExtend: [],
      tableData: [],
      columSetVisible: false,
      multipleSelection: [],
      messageBoxVisible: false,
      analysisError: false,
      aErrorDatas: [],
      errMess: "",
      dialogImageUrl: "",
      dialogVisible: false,
      // 请求表格数据
      tableDataUrl: "/base/customsDeclaration/findByPage",
      //导出URL
      exportUrl: "/base/customsDeclaration/exportCustomsInfo?"
    };
  },
  created() {
    this.FetchStartAndEndtTime();
    this.setSearchFormIsOpenAct();
    this.initPage();
  },
  methods: {
    ...mapActions(["setSearchFormIsOpenAct"]),
    handleExportClick() {
      let param = "";
      param += "&bTimeStr=" + this.formExtend.forms.bTimeStr;
      param += "&eTimeStr=" + this.formExtend.forms.eTimeStr;
      param += "&cdType=" + this.formExtend.forms.cdType;
      document.location.href = this.exportUrl + param;
    },
    handlePreview(scop) {
      this.dialogImageUrl = scop.row.attachment;
      this.dialogVisible = true;
    },
    /**
     * 给开始结束时间赋值   一个月
     */
    FetchStartAndEndtTime() {
      let queryTime = [];
      var date = new Date();
      var year = date.getFullYear();
      var weak = date.getMonth() + 1;
      var day = date.getDate();
      var currentDate =
        year +
        "-" +
        (weak < 10 ? "0" + weak : weak) +
        "-" +
        (day < 10 ? "0" + day : day);
      var oneweekdate = new Date(date - 7 * 24 * 3600 * 1000);
      var y = oneweekdate.getFullYear() + "-";
      var m =
        (oneweekdate.getMonth() + 1 < 10
          ? "0" + (oneweekdate.getMonth() + 1)
          : oneweekdate.getMonth() + 1) + "-";
      var d =
        oneweekdate.getDate() < 10
          ? "0" + oneweekdate.getDate()
          : oneweekdate.getDate();
      var startDate = y + m + d;
      queryTime.push(startDate);
      queryTime.push(currentDate);
      this.formExtend.forms.bTimeStr = startDate;
      this.formExtend.forms.eTimeStr = currentDate;
    },
    //结束时间不选时，开始时间大于当前时间，结束时间选择时，开始时间大于当前时间小于结束时间
    btimeDate() {
      return {
        disabledDate: date => {
          if (this.formExtend.forms.eTimeStr) {
            return (
              new Date(this.formExtend.forms.eTimeStr).getTime() <= date ||
              new Date(this.formExtend.forms.eTimeStr).getTime() >=
                date.getTime() + 40 * 24 * 60 * 60 * 1000
            );
          } else {
            return false;
          }
        }
      };
    },
    //开始时间不选时，结束时间大于当天；开始时间选择时，结束时间大于开始时间
    etimeDate() {
      return {
        disabledDate: date => {
          if (this.formExtend.forms.bTimeStr) {
            return (
              new Date(this.formExtend.forms.bTimeStr).getTime() >= date ||
              new Date(this.formExtend.forms.bTimeStr).getTime() <=
                date.getTime() - 40 * 24 * 60 * 60 * 1000
            );
          } else {
            return false;
          }
        }
      };
    },
    // 删除行
    deleteRow({ row }) {
      this.$confirm("此操作将永久删除该记录, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.tableLoading = true;

          const { code, message } = await DeleteDataById({
            ids: row.id
          });

          this.tableLoading = false;

          if (code === 1) {
            this.successMessage("删除成功", () => {
              this.handleCurrentChange(1);
            });
          } else {
            this.errorMessage(message || "删除失败，请重试");
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },
    // 整合查询数据
    mergeObj() {
      return Object.assign({}, mergeFormExtend(this.formExtend), {
        curPage: this.curPage,
        pageSize: this.pageSize
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.page-view {
  height: 100%;
}
.title-section {
  padding: 15px 0 10px;
}
.table-section {
  height: 200px;
}
.pagination-section {
  padding: 10px 0;
}
.batch-delete {
  line-height: 100px;
  text-align: center;
  background-color: #fff;
}
</style>
